type CompanyRef = {
  id?: number;
  businessName?: string;
};

type UserCompanyEntry = {
  companyId?: number;
  company?: CompanyRef;
  businessName?: string;
};

export const resolveCompanyDisplayName = (
  targetCompanyId: number | undefined,
  currentCompany: CompanyRef | null | undefined,
  companies: UserCompanyEntry[] = [],
): string => {
  if (!targetCompanyId) return "";

  if (String(currentCompany?.id) === String(targetCompanyId)) {
    return currentCompany?.businessName?.trim() ?? "";
  }

  const match = companies.find(
    (item) =>
      String(item.companyId) === String(targetCompanyId) ||
      String(item.company?.id) === String(targetCompanyId),
  );

  return (
    match?.company?.businessName?.trim() ??
    match?.businessName?.trim() ??
    ""
  );
};

export const formatCallFromLabel = (companyName: string): string =>
  companyName ? `From · ${companyName}` : "Internal call";

export const formatCallForLabel = (companyName: string): string => companyName;
